/* Perf 2026-09-07 — fetches the reorder popup on intent via the Section Rendering API.
   It used to ship ~788 KB inline on every page. <reorder-popup> rebinds its own triggers. */
(function () {
  var MOUNT_ID = 'reorder-popup-mount';
  var SECTION_ID = 'reorder-popup';
  var TRIGGER = '[data-reorder-trigger]';

  var state = 'idle'; // 'idle' | 'loading' | 'ready'
  var openWhenReady = false;

  function sectionUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + '?section_id=' + SECTION_ID;
  }

  function openPopup() {
    var run = function () {
      var el = document.querySelector('reorder-popup');
      if (el && typeof el.openPopup === 'function') el.openPopup();
    };
    // global.js is deferred; wait for the definition if a shopper is very quick.
    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('reorder-popup').then(run).catch(run);
    } else {
      run();
    }
  }


  // innerHTML does not execute <script>. Re-create each one so the section behaves the
  // same as when it was rendered inline (this is what LazySection does in global.js).
  function runScripts(root) {
    var tags = root.querySelectorAll("script");
    for (var i = 0; i < tags.length; i++) {
      var old = tags[i];
      if (!old.parentNode) continue;
      try {
        var fresh = document.createElement("script");
        for (var k = 0; k < old.attributes.length; k++) {
          fresh.setAttribute(old.attributes[k].name, old.attributes[k].value);
        }
        if (!old.getAttribute("src")) fresh.text = old.textContent;
        old.parentNode.replaceChild(fresh, old);
      } catch (e) {}
    }
  }

  // The popup is full of <product-form> elements. product-form.js is only emitted by
  // category-tab-section, which is lazy-loaded, so on a fresh page load the custom
  // element may not be defined yet and Add to Cart would post natively to /cart/add.
  function ensureProductForm(done) {
    if (window.customElements && customElements.get("product-form")) { done(); return; }

    var mount = document.getElementById(MOUNT_ID);
    var src = mount && mount.getAttribute("data-product-form-src");
    var already = document.querySelector('script[data-reorder-product-form]') ||
      (src && document.querySelector('script[src="' + src + '"]'));

    if (!already && src) {
      var tag = document.createElement("script");
      tag.src = src;
      tag.defer = true;
      tag.setAttribute("data-reorder-product-form", "");
      document.head.appendChild(tag);
    }

    if (!window.customElements) { done(); return; }
    // Never trap the shopper: open anyway if the definition does not arrive.
    var settled = false;
    var finish = function () { if (!settled) { settled = true; done(); } };
    customElements.whenDefined("product-form").then(finish);
    setTimeout(finish, 3000);
  }
  function load(openAfter) {
    if (openAfter) openWhenReady = true;

    if (state === 'ready') {
      if (openWhenReady) {
        openWhenReady = false;
        openPopup();
      }
      return;
    }
    if (state === 'loading') return;

    var mount = document.getElementById(MOUNT_ID);
    if (!mount) return;

    state = 'loading';
    fetch(sectionUrl(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('reorder-popup section ' + response.status);
        return response.text();
      })
      .then(function (html) {
        mount.innerHTML = html;
        runScripts(mount);
        state = 'ready';
        ensureProductForm(function () {
          if (openWhenReady) {
            openWhenReady = false;
            openPopup();
          }
        });
      })
      .catch(function () {
        // Leave the trigger functional for a retry rather than trapping the shopper.
        state = 'idle';
        openWhenReady = false;
      });
  }

  function triggerFrom(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest(TRIGGER);
  }

  // Capture phase: we must beat global.js's own trigger handlers on the first click.
  document.addEventListener(
    'click',
    function (event) {
      if (!triggerFrom(event)) return;
      if (state === 'ready') return; // <reorder-popup> owns it from here on.
      event.preventDefault();
      load(true);
    },
    true
  );

  // Warm the fetch on intent so the first open feels instant.
  function onIntent(event) {
    if (state !== 'idle') return;
    if (triggerFrom(event)) load(false);
  }
  document.addEventListener('pointerover', onIntent, { capture: true, passive: true });
  document.addEventListener('touchstart', onIntent, { capture: true, passive: true });
  document.addEventListener('focusin', onIntent, true);

  // ReorderPopup.connectedCallback consumes this flag to auto-open after a
  // login round-trip, so the popup has to be present for it to be honoured.
  function init() {
    try {
      if (window.localStorage && localStorage.getItem('triggerReorderPopup') === 'true') {
        load(false);
      }
    } catch (error) {
      /* storage unavailable (private mode / blocked cookies) — nothing to do */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
